import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { useLanguage } from '../../context/LanguageContext';
import vectorPunteado from '../../images/vector-punteado.svg';
import gobierno from '../../images/industries/gobierno.jpg';
import industria from '../../images/industries/industria.jpg';
import salud from '../../images/industries/salud.jpg';
import retail from '../../images/industries/retail.jpg';
import pymes from '../../images/industries/pymes-startups.jpg';
import './Industries.css';

const Industries: React.FC = () => {
  const { t } = useLanguage();

  const industries = [
    {
      title: t('industries.government.title'),
      subText: t('industries.government.text'),
      image: gobierno
    },
    {
      title: t('industries.industry.title'),
      subText: t('industries.industry.text'),
      image: industria
    },
    {
      title: t('industries.health.title'),
      subText: t('industries.health.text'),
      image: salud
    },
    {
      title: t('industries.retail.title'),
      subText: t('industries.retail.text'),
      image: retail
    },
    {
      title: t('industries.startups.title'),
      subText: t('industries.startups.text'),
      image: pymes
    }
  ];

  return (
    <section className="section-container">
      <Container>
        <Row className="justify-content-center">
          <Col md={12} lg={10}>
            <div className="industries-header">
              <Row className="align-items-center">
                <Col sm={12} md={8} lg={6}>
                  <div className="about-title-container">
                    <img src={vectorPunteado} alt="Industries Icon" className="about-icon" />
                    <h1 className="section-title">{t('industries.title')}</h1>
                    <p className="about-text">{t('industries.subtitle')}</p>
                  </div>
                </Col>
              </Row>
            </div>
            
            <Row className="industries-row g-4">
              {industries.map((industry, index) => (
                <Col key={index} className="industry-col">
                  <Card className="industry-card text-center">
                    <div className="industry-image-container">
                      <img src={industry.image} alt={industry.title} className="industry-image" />
                      <div className="industry-image-gradient"></div>
                    </div>
                    <Card.Body>
                      <Card.Title className="industry-title nav-font">{industry.title}</Card.Title>
                      <Card.Text className="industry-sub-text">{industry.subText}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Industries;
